import React, { cloneElement, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DatePicker as MaterialDatePicker } from '@material-ui/pickers';

import theme from './DatePicker.scss';
import { Input } from '../index';

const propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
};

const defaultProps = {
  label: null,
  value: undefined,
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
};

const DatepickerInput = ({ ariaLabel, label, value, onClick, onKeyDown }) => {
  return (
    <Input
      testId="datepicker-input"
      value={ value }
      label={ label }
      ariaLabel={ ariaLabel }
      onClick={ onClick }
      onKeyDown={ onKeyDown }
      onChange={ () => {} }
      placeholder={{ id: 'Appointments.AppointmentsList.Filter.Schedule.Date.Placeholder', defaultMessage: '** DD/MM/YY' }}
      iconName="calendar"
      clearable={ false }
      iconPositionRtlNotReversed={ true }
      rootClassName={ theme.inputRoot }
    />
  );
};

const DatePicker = ({
  onChange,
  ariaLabel,
  label,
  value,
  maxDate,
  minDate,
  intl,
}) => {
  const [datepickerOpened, setDatepickerOpened] = useState(false);
  useEffect(() => {
    const preventKeyPress = e => {
      // prevent any opened popover from close when esc pressed inside calendar modal
      if (['Escape'].includes(e.key) && datepickerOpened) {
        setDatepickerOpened(false);
        e.stopPropagation();
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', preventKeyPress, true);
    return () => document.removeEventListener('keydown', preventKeyPress, true);
  });

  return (
    <MaterialDatePicker
      format="DD/MM/YYYY"
      label={ intl.formatMessage(label) }
      value={ value }
      open={ datepickerOpened }
      onChange={ val => onChange(val.toDate()) }
      onOpen={ () => { setDatepickerOpened(true); } }
      onClose={ () => { setDatepickerOpened(false); } }
      maxDate={ maxDate || new Date('2100-01-01') }
      minDate={ minDate || new Date('1900-01-01') }
      cancelLabel={ <FormattedMessage id="const.button.cancel" defaultMessage="** CANCEL" /> }
      okLabel={ <FormattedMessage id="const.button.ok" defaultMessage="** OK" /> }
      renderDay={ (day, selectedDate, isInCurrentMonth, dayComponent) => {
        if (!isInCurrentMonth) return <div style={{ width: 36, height: 36, margin: '0 2px' }} />;
        return cloneElement(dayComponent, { 'aria-label': day.format('dddd, MMMM Do YYYY') });
      } }
      rightArrowButtonProps={{
        'aria-label': intl.formatMessage({ id: 'DatePicker.NextMonth.TitleAttribute', defaultMessage: '** Next month' }),
      }}
      leftArrowButtonProps={{
        'aria-label': intl.formatMessage({ id: 'DatePicker.PreviousMonth.TitleAttribute', defaultMessage: '** Previous month' }),
      }}
      DialogProps={{
        'aria-label': intl.formatMessage({ id: 'DatePickerBox.TitleAttribute', defaultMessage: '** Date picker' }),
      }}
      TextFieldComponent={ (props) => <DatepickerInput ariaLabel={ ariaLabel } { ...props } /> }
      autoOk
    />
  );
};

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;

export default injectIntl(DatePicker);
